export enum HotelsPageRoutes {
  List = 'list',
  Hotel_Page = 'hotel-detail',
  Room_Detail = 'room-detail',
}
